module.exports = {"230128100":"通河镇","230128101":"乌鸦泡镇","230128102":"清河镇","230128103":"浓河镇","230128104":"凤山镇","230128105":"祥顺镇","230128201":"三站乡","230128202":"富林乡","230128400":"清河林业局","230128401":"兴隆林业局","230128500":"岔林河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230128.json
// module id = 629
// module chunks = 0